import { FE_AUTH_TOUCH_API } from '@/helper/apiConstants'
import { loadState, saveState } from '@/utils/localStorage'
import { TOKEN_TOUCHED_AT_KEY, TOKEN_TOUCH_INTERVAL } from '@/utils/constants'

// Backend expires a session only on idle, and only an authenticated call resets that timer - so the cookie's expiry rides on those calls instead of on page views.
export const touchTokenCookie = () => {
  if (typeof window === 'undefined') return

  const lastTouchedAt = Number(loadState(TOKEN_TOUCHED_AT_KEY)) || 0
  if (Date.now() - lastTouchedAt < TOKEN_TOUCH_INTERVAL) return

  // Stamped before the request so the burst of calls on a page load fires one touch, not one each.
  saveState(TOKEN_TOUCHED_AT_KEY, Date.now())
  fetch(FE_AUTH_TOUCH_API, { method: 'POST' }).catch(() => {})
}
